import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
import App from "./app/App";
import "./app/config/i18n";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./app/rsuite.css";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import "./app/custom.css";
ReactDOM.render(
  <React.StrictMode>
    <ToastContainer
      position="top-center"
      style={{ width: "500px" }}
    ></ToastContainer>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
console.log("TEST SID abc-3");
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
